import { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import layoutBgImg from '../../Images/layout/others.jpg'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader'
import { Context } from '../../Store/context';
import { Get } from '../../api/services/api_helpers';

const SearchTable = () => {
    const [laws, setLaws] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { i18n, t } = useTranslation();
    const { showError } = useContext(Context);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const lawId = queryParams.get('id');

    useEffect(() => {
        const getLaws = async () => {
            setIsLoading(true);
            try {
                const data = await Get(`search/?id=${lawId}`);
                setLaws(data);
            } catch (error) {
                showError(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        getLaws();
    }, [lawId, showError]);

    const getLawPdf = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws?.rus_pdf;
        } else if (currentLang === 'en') {
            return laws?.eng_pdf;
        }
        return laws?.tm_pdf;
    };

    return (
        <div className='mb-20'>
            <Layout
                title={t('search')}
                layoutBgImg={layoutBgImg}
            />
            <main className='media'>
                <div className='border border-secondary 
                        dark:border-dark-border 
                        dark:bg-dark-box dark:text-dark-text
                        bg-white mt-8 p-2 w-full'>

                    {isLoading ? <Loading /> :
                        <div className='h-[1000px] max-h-max'>
                            {laws?.map((l) => (
                                <iframe
                                    src={`${getLawPdf(l)}#toolbar=0&navpanes=0&view=FitH`}
                                    className="w-full h-full"
                                    frameBorder="0"
                                    title="PDF Viewer"
                                ></iframe>
                            ))}
                        </div>
                    }
                </div>
            </main>
        </div>
    )
}

export default SearchTable